export const REMOTE_ORDER_TOTAL_REQUESTED = 'REMOTE_ORDER_TOTAL_REQUESTED'
export const REMOTE_ORDER_TOTAL_SUCCEEDED = 'REMOTE_ORDER_TOTAL_SUCCEEDED'
export const REMOTE_ORDER_TOTAL_FAILED = 'REMOTE_ORDER_TOTAL_FAILED'

export const UPDATE_EXEMPTIONS_REQUESTED = 'UPDATE_EXEMPTIONS_REQUESTED'
export const UPDATE_EXEMPTIONS_SUCCEEDED = 'UPDATE_EXEMPTIONS_SUCCEEDED'
export const UPDATE_EXEMPTIONS_FAILED = 'UPDATE_EXEMPTIONS_FAILED'

export const CLEAR_REMOTE_ORDER_TOTAL = 'CLEAR_REMOTE_ORDER_TOTAL'

export const getRemoteOrderTotal = (payload) => ({
  type: REMOTE_ORDER_TOTAL_REQUESTED,
  payload
})

getRemoteOrderTotal.type = REMOTE_ORDER_TOTAL_REQUESTED

export const getRemoteOrderTotalSucceeded = (payload) => ({
  type: REMOTE_ORDER_TOTAL_SUCCEEDED,
  payload
})

getRemoteOrderTotalSucceeded.type = REMOTE_ORDER_TOTAL_SUCCEEDED

export const getRemoteOrderTotalFailed = (payload) => ({
  type: REMOTE_ORDER_TOTAL_FAILED,
  payload
})

getRemoteOrderTotalFailed.type = REMOTE_ORDER_TOTAL_FAILED

export const clearRemoteOrderTotal = () => ({
  type: CLEAR_REMOTE_ORDER_TOTAL,
})

clearRemoteOrderTotal.type = CLEAR_REMOTE_ORDER_TOTAL

export const updateExemptions = (payload) => ({
  type: UPDATE_EXEMPTIONS_REQUESTED,
  payload,
})

updateExemptions.type = UPDATE_EXEMPTIONS_REQUESTED

export const updateExemptionsSucceeded = (payload) => ({
  type: UPDATE_EXEMPTIONS_SUCCEEDED,
  payload,
})

updateExemptionsSucceeded.type = UPDATE_EXEMPTIONS_SUCCEEDED

export const updateExemptionsFailed = (payload) => ({
  type: UPDATE_EXEMPTIONS_FAILED,
  payload,
})

updateExemptionsFailed.type = UPDATE_EXEMPTIONS_FAILED
